export default {
  mobilePlan: {
    id: 'hc_help_center_item_card_mobile_plan',
    defaultMessage: '+ Mobile plan',
  },
}
